import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, renderList as _renderList, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "table m-0" }
const _hoisted_2 = { class: "text-right" }

import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import IntegrationListResponse from "~/cabinet/ts/data/online/config/integration/IntegrationListResponse";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import Integration from "~/cabinet/ts/data/online/config/integration/Integration";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import Dictionary from "~/ts/library/Dictionary";
import {PlatformInterface} from "~/cabinet/ts/data/integrations/Platform";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {computed, ref, watch} from "vue";
import Auth from "~/cabinet/ts/data/integrations/Auth";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import ElCardSectionWithTable from "~/cabinet/vue/interface/card/ElCardSectionWithTable.vue";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import IIntegrationsComponent from "~/cabinet/vue/client/online/config/integrations/IIntegrationsComponent";
import UsersDialog from "~/cabinet/vue/client/online/config/integrations/UsersDialog.vue";
import IntegrationsWrapper from "~/cabinet/vue/client/integrations/IntegrationsWrapper.vue";
import IntegrationsAdditionalButtons
    from "~/cabinet/vue/client/online/config/integrations/IntegrationsAdditionalButtons.vue";


const __default__ = {
    name: "Integrations"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    platformTypeId: {},
    siteId: {},
    showAdditionalAuthConfigButton: { type: Boolean, default: true },
    showEmptyAsCard: { type: Boolean, default: true }
  },
  emits: ["reload", "new-auth"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;


let emits = __emit;

let addIntegrationDialog = ref<{
    visible: boolean,
    platformId: string
}>();


let integrationStates = ref<Dictionary<{ descr: string, isCritical: boolean }>>();
let balance = ref<Dictionary<{ descr: string, sum: string }>>();
let channels = ref<Dictionary<{ descr: string, errorDescr?: string, id: string, isValidate: boolean }[]>>();

let integrationListRequest = computed(() => {
    return new ReactiveRequest<IntegrationListResponse>(new LcabApiRequest({
        url: `/api/client/online/integration/${props.siteId}/${props.platformTypeId}/getIntegrations`
    }, IntegrationListResponse));
});

async function onSelectNewAuth(auth: Auth) {
    //fadsa
    let result = await LcabApiRequest.save({
        url: `/api/client/online/integration/${props.siteId}/${auth.id}/saveIntegration`
    });
    if (result.isSuccess) {
        if (addIntegrationDialog.value) {
            addIntegrationDialog.value.visible = false;
        }

        emits("new-auth", auth);
        reload();
    }
}

function reload() {
    emits("reload");
    integrationListRequest.value.make();
}


async function removeIntegration(integration: Integration) {
    try {
        await ElConfirm("Вы уверены, что хотите удалить эту интеграцию?");
        let result = await LcabApiRequest.fetch({
            url: `/api/client/online/integration/${props.siteId}/${integration.id}/removeIntegration`
        });
        if (result.isSuccess) {
            try {
                await ElConfirm("Если вы не хотите использовать эту интеграцию в других своих сайтах, вы можете удалить ее полностью.", {
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Буду использовать'
                });
                await removeAuth(integration.auth.id, true);
            } catch (e) {

            }
            reload();
        }
    } catch (e) {

    }
}

let integrationsList = computed(() => {
    let result: Dictionary<{ platform: PlatformInterface, integrations: Integration[] }> = {};
    let request = integrationListRequest.value;
    if (request.isSuccess) {
        let integrations = integrationListRequest.value.data.integrations;
        for (let integration of integrations) {
            let platformId = integration.platform.id;
            if (!result[platformId]) {
                result[platformId] = {
                    platform: integration.platform,
                    integrations: []
                };
            }
            result[platformId].integrations.push(integration);
        }
    }
    return ObjectHelper.arrayFromDictionary(result);
});

watch(integrationsList, async () => {
    integrationStates.value = null;
    balance.value = null;
    channels.value = null;
    if (integrationsList.value && integrationListRequest.value.data) {
        let idsList: string[] = [];

        for (let integration of integrationListRequest.value.data.integrations) {
            idsList.push(integration.auth.id);
            let parent = integration.auth.parentAuth;
            if (parent) {
                idsList.push(parent.id);
            }
        }
        let result = await LcabApiRequest.fetch({
            url: `/api/client/online/integration/getIntegrationState`,
            p: {
                idsList,
                siteId: props.siteId
            },
            silent: true
        });
        integrationStates.value = result.getData("validationResult");
        balance.value = result.getData("balanceResult");
        channels.value = result.getData("channelsResult");
    }
}, {deep: true})



async function removeAuth(authId: string, withoutConfirm: boolean = null) {
    try {
        if (!withoutConfirm) {
            await ElConfirm("Вы уверены, что хотите удалить эту интеграцию?");
        }
        let result = await LcabApiRequest.save({
            url: `/api/client/integrations/${authId}/removeAuth`
        });
        if (result.isSuccess) {
            reload();
        }
    } catch (e) {

    }
}


let usersDialog = ref<{
    visible: boolean,
    integration: Integration
}>();

function openUsersDialog(integration: Integration) {
    usersDialog.value = {
        integration,
        visible: true
    }
}

function getIntegrationByAuth(auth: Auth): Integration {
    return integrationListRequest.value.data.integrations.find(integration => integration.auth === auth);
}

__expose<IIntegrationsComponent>({
    reload
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ReactiveRequestLoader, { request: _unref(integrationListRequest) }, {
      default: _withCtx(() => [
        (_unref(integrationListRequest).data)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(usersDialog) && _unref(usersDialog).visible)
                ? (_openBlock(), _createBlock(UsersDialog, {
                    key: 0,
                    visible: _unref(usersDialog).visible,
                    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(usersDialog).visible) = $event)),
                    integration: _unref(usersDialog).integration,
                    "site-id": __props.siteId,
                    onReload: reload
                  }, null, 8, ["visible", "integration", "site-id"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["request"]),
    _createVNode(IntegrationsWrapper, {
      "platform-type-id": __props.platformTypeId,
      "platforms-dictionary": _unref(integrationListRequest).data?.platforms,
      "show-additional-auth-config-button": __props.showAdditionalAuthConfigButton,
      "show-empty-as-card": __props.showEmptyAsCard,
      "auth-list": _unref(integrationListRequest).data?.integrations.map(item => item.auth),
      onNewAuth: _cache[1] || (_cache[1] = ($event: any) => (onSelectNewAuth($event))),
      onReload: reload
    }, {
      buttons: _withCtx(({auth, platform}) => [
        _createVNode(IntegrationsAdditionalButtons, {
          integration: getIntegrationByAuth(auth),
          platform: platform,
          onRemove: removeIntegration,
          onUsersDialog: openUsersDialog
        }, {
          default: _withCtx(({integration}) => [
            _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({integration})))
          ]),
          _: 3
        }, 8, ["integration", "platform"])
      ]),
      "after-cards": _withCtx(() => [
        (_unref(integrationListRequest).data.unusedAuthList.length)
          ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(ElCardHeader, { title: "Неиспользуемые интеграции" }),
                _createVNode(ElCardSectionWithTable, null, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_1, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(integrationListRequest).data.unusedAuthList, (auth) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: auth.id
                          }, [
                            _createElementVNode("td", null, [
                              _createVNode(FontAwesomeIcon, {
                                icon: _unref(integrationListRequest).data.platforms[auth.platformId].icon,
                                style: _normalizeStyle({
                                                        color: _unref(integrationListRequest).data.platforms[auth.platformId].color
                                                    }),
                                class: "mr-1"
                              }, null, 8, ["icon", "style"]),
                              _createTextVNode(" " + _toDisplayString(auth.descr), 1)
                            ]),
                            _createElementVNode("td", _hoisted_2, [
                              _createVNode(_component_el_button, {
                                onClick: ($event: any) => (onSelectNewAuth(auth))
                              }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                  _createTextVNode(" Подключить к этому сайту ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                plain: "",
                                onClick: ($event: any) => (removeAuth(auth.id))
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode(" Удалить навсегда ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "after-cards")
      ]),
      _: 3
    }, 8, ["platform-type-id", "platforms-dictionary", "show-additional-auth-config-button", "show-empty-as-card", "auth-list"])
  ], 64))
}
}

})